import { ReactNode } from "react";
import { HeroLayout, HeroLayoutMode } from "@mediaspace/features/layout";
import { useTheme } from "@mediaspace/shared/styled";
import { useMediaQuery } from "@mediaspace/shared/utils";

interface MeetingRoomHeroLayoutProps {
    collapsedHero?: boolean;
    children: ReactNode;
}

/**
 * Layout for active meeting room hero component (not for the room's lobby)
 */
export const MeetingRoomHeroLayout = ({collapsedHero, children}: MeetingRoomHeroLayoutProps) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return <HeroLayout
        mode={isMobile || collapsedHero ? HeroLayoutMode.AspectRatio : HeroLayoutMode.FullSize}
    >
        {children}
    </HeroLayout>;
};
